import network from './slices/networkSlice'
import loader from './slices/loaderSlice'
import auth from './slices/authSlice'
import user from './slices/userSlice'
import dashboard from './slices/dashboardSlice'
import campaign from './slices/campaignSlice'
import advertiser from './slices/advertiserSlice'
import publisher from './slices/publisherSlice'
import billing from './slices/billingSlice'
import postback from './slices/postbackSlice'
import report from './slices/reportSlice'
import overview from './slices/overviewSlice'
import notification from './slices/notificationSlice'
const reducer = {
  network,
  loader,
  auth,
  user,
  dashboard,
  campaign,
  advertiser,
  publisher,
  billing,
  postback,
  report,
  overview,
  notification
};

export default reducer;
